import React, { useRef, useEffect } from "react";
import p5 from "p5";

const RadicalBackground = () => {
  const sketchRef = useRef();

  useEffect(() => {
    const container = sketchRef.current;
    let sketch = new p5((p) => {
      let rads = [];
      const colors = [
        "#08A887",
        "#0965AB",
        "#5BDCC6",
        "#7DE8FF",
        "#FBCC57",
        "#FD015F",
      ];
      let radialIncrement = 10;

      class Rad {
        constructor(rotation) {
          this.rotation = rotation;
          this.y = 0;
          this.length = 5;
          this.color = p.random(colors);
        }

        update() {
          this.y += 1.25;
        }

        display() {
          p.push();
          p.translate(p.width / 2, p.height / 2);
          p.rotate(this.rotation);
          p.stroke(this.color);
          let strokeW = p.map(p.mouseY, 0, p.height, 2, 3);
          p.strokeWeight(strokeW);
          p.strokeCap(p.PROJECT);
          p.line(0, this.y, 0, this.y + this.length);
          p.pop();
        }

        isOffScreen() {
          return this.y > p.max(p.width, p.height);
        }
      }

      p.setup = () => {
        const cnv = p.createCanvas(
          container.offsetWidth,
          container.offsetHeight,
        );
        cnv.parent(container);
        p.angleMode(p.DEGREES);
        // Initial radials
        for (let i = 0; i < 360; i += radialIncrement) {
          rads.push(new Rad(i));
        }
      };

      p.draw = () => {
        p.background(255);

        // Continue responding to the mouse by adjusting intensity based on mouseX
        let intensity = p.map(p.mouseX, 0, p.width, 0.05, 0.15);

        if (p.random(1) < intensity) {
          for (let i = 0; i < 360; i += radialIncrement) {
            rads.push(new Rad(i));
          }
        }

        for (let i = rads.length - 1; i >= 0; i--) {
          rads[i].update();
          rads[i].display();
          if (rads[i].isOffScreen()) {
            rads.splice(i, 1);
          }
        }

        p.noStroke();
        p.fill(255);
        p.ellipse(p.width / 2, p.height / 2, 100);
      };

      p.mousePressed = function () {
        if (radialIncrement === 20) {
          radialIncrement = 10;
        } else {
          radialIncrement = 20;
        }
      };

      const handleResize = () => {
        p.resizeCanvas(container.offsetWidth, container.offsetHeight);
      };

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
        sketch.remove();
      };
    });

    return () => {
      sketch.remove();
    };
  }, []);

  return <div ref={sketchRef} className="w-full h-full p5-container" />;
};

export default RadicalBackground;
